import { z } from "zod";

export const UserIdentification = z.object({
  id: z.number().optional(),
  external_id: z.string().optional(),
  email: z.string().nullable().optional(),
  mobile: z
    .object({ isd: z.string(), number: z.string() })
    .nullable()
    .optional(),
});
export type UserIdentification = z.infer<typeof UserIdentification>;

const hasOneIdentifierCheck = (check: UserIdentification) => {
  return !!(check.id || check.email || check.mobile || check.external_id);
};

const hasOneIdentifierMessage = {
  message: "At least one user identifier must be provided",
};

export const PasswordResetRequest = UserIdentification.refine(
  hasOneIdentifierCheck,
  hasOneIdentifierMessage,
);
export type PasswordResetRequest = z.infer<typeof PasswordResetRequest>;

export const PasswordResetResponse = z.string();
type PasswordResetResponse = z.infer<typeof PasswordResetResponse>;

export const PasswordUpdateRequest = UserIdentification.extend({
  password: z.string(),
  reset_password_token: z.string(),
}).refine(hasOneIdentifierCheck, hasOneIdentifierMessage);
export type PasswordUpdateRequest = z.infer<typeof PasswordUpdateRequest>;

export const PasswordUpdateResponse = z.object({
  errors: z.any(),
});
export type PasswordUpdateResponse = z.infer<typeof PasswordUpdateResponse>;
